import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/login/code`;

export const ROUTE: RouteDefinition = `${baseRoute}/login/code`;

export const URL = (): RouteDefinition => `${baseRoute}/login/code`;
